module.exports = __webpack_public_path__ + "img/pauli-y-root-dagger-10.d655e914.svg";